import { ModelDef } from '../../CORE/src/common/$models/ModelDef'

const notEmpty = { validationType: 'notEmpty' as const }

/** 一覧・編集（disabled）で RICHTEXT を HTML として表示する */
const formatFeedbackContentHtml = (row: Record<string, unknown>): string => {
  const html = row.content
  if (html == null || html === '') {
    return ''
  }
  const raw = String(html)
  // 一覧行クリックとセル内リンクの競合を避ける
  const withClickGuard = raw.replace(/<a\b/gi, '<a class="ignoreItemClick"')
  return `<div class="yhc-richtext-content yhc-service-level-feedback-content">${withClickGuard}</div>`
}

/**
 * サービスレベル検索（社内用）からの質問・要望投稿
 * - 公開 Web: Directus Public ロールの create のみ（department / author_name / content）
 * - 管理画面: read + is_confirmed の update のみ
 */
export const yhc_service_level_feedbacks: ModelDef = {
  tableName: 'yhc_service_level_feedbacks',
  tableLabel: '質問・要望',
  primaryKeyColType: 'UUID',
  creatable: false,
  updatable: true,
  deletable: false,
  defaultSort: { key: 'createdAt', order: 'desc' },
  keywordSearchTargetColumns: ['department', 'author_name', 'content'],
  columns: {
    department: {
      type: 'STRING',
      label: '所属部署',
      editable: false,
      validate: { notEmpty: true },
      width: { xs: 24 },
    },
    author_name: {
      type: 'STRING',
      label: '名前',
      editable: false,
      validate: { notEmpty: true },
      width: { xs: 24 },
    },
    content: {
      type: 'RICHTEXT',
      label: '質問・要望内容',
      editable: false,
      validate: { notEmpty: true },
      width: { xs: 48 },
      listLabelFormatter: formatFeedbackContentHtml,
      labelFormatter: formatFeedbackContentHtml,
      listItemAttrs: {
        style: {
          maxHeight: '12rem',
          overflow: 'auto',
        },
      },
    },
    is_confirmed: {
      type: 'BOOLEAN',
      label: '確認済',
      defaultValue: false,
      width: { xs: 8 },
    },
  },
}
